import { articleCategoriesSlice } from "./articleCategoriesSlice";
import * as actions from "./articleCategoriesActions";
import * as selectors from "./articleCategoriesSelectors";

export { actions };
export { selectors };
export default articleCategoriesSlice.reducer;
